// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const regon: CountryValidator<"PL"> = createValidator(
  "pl.regon",
  147,
);

export default regon;
export const compact = regon.compact;
export const format = regon.format;
export const validate = regon.validate;
export const generate = (): string =>
  regon.generate?.() ??
  (() => {
    throw new Error(
      "Validator pl.regon cannot generate values",
    );
  })();
